import './App.css';
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import Login from "./pages/Auth/Login";
import Pages from "./pages/Pages";
import {Navigate, Route, Routes} from "react-router-dom";
import SignUp from "./pages/Auth/SignUp";
function App() {

  const expiret = localStorage.getItem('reestr-expiret');
  if(expiret >= Date.now()){
    localStorage.removeItem('reestr-expiret');
    localStorage.removeItem('reestr-token');
  }
  const token = localStorage.getItem('reestr-token');
  return (
      <Routes>
        {!token ? (
            <>
              <Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
              <Route path="/register" element={<ErrorBoundary><SignUp /></ErrorBoundary>} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
        ) : (
            <>
              <Route path="/*" element={<Pages />} />
            </>
        )}
      </Routes>
  );
}

export default App;
